
/**
 * Utilitaires de formatage des distances pour les tests de niveau 2
 */

/**
 * Formate les distances en fonction du point et du type de test
 */
export const formatLevel2Distance = (
  point: string,
  selectedTest: string | null,
  distances: Record<string, string>,
  isBunkerTest: boolean,
  isWedgingTest: boolean
): string => {
  // Priorité 1: utiliser les distances fournies par getTestDistances
  if (distances && distances[point]) {
    // S'assurer que les distances comportent toujours l'unité "m"
    if (!isNaN(Number(distances[point]?.replace(',', '.').replace('m', ''))) && !distances[point]?.includes('m')) {
      return `${distances[point]}m`;
    }
    return distances[point];
  }
  
  // Traitement spécial pour les tests de wedging au Niveau 2
  if (isWedgingTest || (selectedTest && selectedTest.includes('wedging'))) {
    if (selectedTest === 'wedging-cercles') {
      if (point === 'D') return '45m';
      if (point === 'E') return '55m';
      if (point === 'F') return '65m';
    } else if (selectedTest === 'wedging-mid') {
      if (point === 'D1') return '75m';
      if (point === 'E1') return '85m';
      if (point === 'F1') return '95m';
    } else if (selectedTest === 'wedging-pente-gauche') {
      if (point === 'D2') return '45m';
      if (point === 'E2') return '55m';
      if (point === 'F2') return '65m';
    }
    
    // Compatibilité avec les points du niveau 3
    if (point === 'WedgingA') return '45m';
    if (point === 'WedgingB') return '55m';
    if (point === 'WedgingC') return '65m';
  }
  
  // Traitement spécial pour les tests de bunker au Niveau 2
  if (isBunkerTest) {
    if (selectedTest === 'bunker-court') {
      if (point === 'D') return '5m';
      if (point === 'E') return '8m';
      if (point === 'F') return '12m';
      // Compatibilité avec les points du niveau 3
      if (point === 'BunkerA') return '5m';
      if (point === 'BunkerB') return '8m';
      if (point === 'BunkerC') return '12m';
    } else if (selectedTest === 'bunker-long') {
      if (point === 'D1') return '15m';
      if (point === 'E1') return '20m';
      // Compatibilité avec les points du niveau 3
      if (point === 'BunkerD') return '15m';
    }
  }
  
  // Traitement spécial pour les tests de chipping au Niveau 2
  if (selectedTest?.includes('chipping')) {
    if (selectedTest === 'chipping-plat') {
      if (point === 'D') return '15m';
      if (point === 'E') return '20m';
      if (point === 'F') return '25m';
    } else if (selectedTest === 'chipping-pente-droit') {
      if (point === 'D1') return '15m';
      if (point === 'E1') return '20m';
      if (point === 'F1') return '25m';
    } else if (selectedTest === 'chipping-pente-gauche') {
      if (point === 'D2') return '15m';
      if (point === 'E2') return '20m';
      if (point === 'F2') return '25m';
    } else if (selectedTest === 'chipping-roulee-plat') {
      if (point === 'D3') return '5m';
      if (point === 'E3') return '10m';
      if (point === 'F3') return '15m';
    }
  } else {
    // Autres tests au Niveau 2 (putting)
    if (point === 'D') return '1,2m';
    if (point === 'E') return '1,5m';
    if (point === 'F') return '3m';
    if (point === 'D1') return '1,2m';
    if (point === 'E1') return '1,5m';
    if (point === 'F1') return '3m';
    if (point === 'D2') return '1,2m';
    if (point === 'E2') return '1,5m';
    if (point === 'F2') return '3m';
    if (point === 'D3') return '1,2m';
    if (point === 'E3') return '1,5m';
    if (point === 'F3') return '3m';
    if (point === 'D4') return '1,2m';
    if (point === 'E4') return '1,5m';
    if (point === 'F4') return '3m';
  }
  
  return point;
};
